import { EntityDescriptions } from 'src/store/entities/types';
import EntityDescription from 'src/store/entities/types/EntityDescription';
import ArticleType from './ArticleType';

export default class ArticleGroup {
    public articleType: ArticleType;
    public groupId: string;
    public name: string;
    public deliverable: boolean;
    public hasSerialNumber: boolean;

    constructor(json: any) {
        this.articleType = new ArticleType(json.articleType);
        this.groupId = json.groupId;
        this.name = json.name;
        this.deliverable = json.deliverable;
        this.hasSerialNumber = json.hasSerialNumber;
    }

    getEntityDescription(): EntityDescription {
        return EntityDescriptions.ARTICLE_GROUPS_LIST;
    }

    toString(): string {
        return `${this.name}:${this.articleType.name}`;
    }
}
